// export const siteAPIDomain = 'https://clientbooks.com';
export const WordPressAPIURL = 'https://dev1800a.wpengine.com/wp-json/';
// export const SiteAPIURL = `${siteAPIDomain}/cbapi/app.php/`;
